// extracted by mini-css-extract-plugin
export default {"asideList":"style-asideList-s3v3L","hideMobile":"style-hideMobile-Q7IXa"};